import { Box, Typography, Paper } from "@mui/material";

export default function ServingExampleAppAPISummary(props) {
  return (
    <>
      <Box
        sx={{
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
        textAlign="center"
        color="#8c0404"
      >
        <Typography>{props.msg}</Typography>
      </Box>
      {props.took && (
        <Box sx={{ flex: 1 }} style={{ paddingTop: "10px" }}>
          <Paper elevation={3} style={{ padding: "5px" }}>
            <Typography textAlign="center">Took {props.took} ms</Typography>
          </Paper>
        </Box>
      )}
    </>
  );
}
